import { Cancel } from "@mui/icons-material";
import { Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import useService from "../../../../../../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../../../../../../global/ApiRequestErrorHandler";
import ResponseDisplay from "../../../components/ResponseDisplay";

export default function PoliceReportCheckbox({ caseObj }) {
  const caseRepository = useService("repositories/case-repository");

  const [responseSuccess, setResponseSuccess] = useState(null);
  const [responseBreakdown, setResponseBreakdown] = useState("");
  const [loading, setLoading] = useState(false);
  const [reportReceived, setReportReceived] = useState(Boolean(caseObj?.policeReportReceived));

  useEffect(() => {
    setReportReceived(Boolean(caseObj?.policeReportReceived));
  }, [caseObj?.policeReportReceived]);

  const handleApiError = (error) => {
    setLoading(false);
    const res = error?.response?.data ?? error;
    const errArr = ApiRequestErrorHandler(res);
    setResponseBreakdown(errArr);
    setResponseSuccess(false);
    setReportReceived(Boolean(caseObj?.policeReportReceived));
    setTimeout(() => {
      setResponseSuccess(null);
      setResponseBreakdown("");
    }, 60000);
    return error;
  };

  const handleApiSuccess = (response, valueName) => {
    setLoading(false);
    setResponseBreakdown(`${valueName} was successfully updated`);
    setResponseSuccess(true);
    setTimeout(() => {
      setResponseSuccess(null);
      setResponseBreakdown("");
    }, 5000);
    return response;
  };

  const submitData = async (value) => {
    const caseId = caseObj?.pk ?? caseObj?.id;
    if (!caseId) {
      setReportReceived(Boolean(caseObj?.policeReportReceived));
      setResponseSuccess(false);
      setResponseBreakdown("Case ID not found to update Police Report.");
      return;
    }

    setLoading(true);
    const postData = {
      police_report_received: value,
    };

    try {
      const patched = await caseRepository.patch(caseId, postData);
      if (patched) {
        handleApiSuccess(patched, "Police Report");
      } else {
        throw new Error("Empty response from server.");
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleChange = (checked) => {
    setReportReceived(checked);
    submitData(checked);
  };

  return (
    <div>
      <div className="flex items-center gap-2">
        <FormControlLabel
          name="police_report_received"
          control={
            <Checkbox
              sx={{ color: "#fce3a4" }}
              checked={reportReceived}
              onChange={(e) => handleChange(e.target.checked)}
              disabled={loading}
            />
          }
          label={<Typography variant="body2">Police Report</Typography>}
        />

        {loading ? (
          <CircularProgress color="secondary" size={25} />
        ) : responseSuccess === false ? (
          <Cancel className="text-red-600" />
        ) : null}
      </div>

      <ResponseDisplay responseBreakdown={responseBreakdown} responseSuccess={responseSuccess} />
    </div>
  );
}
